<!--
 * @Autor: 李建鹏
 * @Date: 2022-10-09 15:01:36
 * @LastEditTime: 2022-10-10 14:55:44
 * @Description: 收官
-->
<style scoped lang="scss">
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
@import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';

.common {
  .common-wrapper {
    display: flex;
    align-items: center;
    margin-top: 40px;

    .common-title {
      color: #999999;
      img {
        width: 60px;
        height: 60px;
        margin: 0 28px 0 0;
      }
      &.active {
        color: #b3704c;
        font-size: 24px;
        font-family: JiangChengLvDongHei;
      }
    }
    .common-content {
      position: relative;
      flex: 1;
      box-sizing: border-box;
      padding-right: 14px;
      overflow: hidden;

      .process-item {
        align-items: flex-start !important;
        color: #000;
        font-weight: 300;
        font-size: 24px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 24px;
        .item_address {
          @include ellipsis();
          margin-bottom: 16px;
          line-height: 28px;
          .title {
            margin-right: 24px;
            color: #111;
            font-size: 24px;
          }
          .title_info {
            color: #111;
          }
        }
        .item_info {
          @include multi-ellipsis(2);
          display: flex;
          align-items: center;
          color: #000000;
          font-weight: 300;
          font-size: 24px;
          font-family: PingFangSC-Light, PingFang SC;
          line-height: 32px;
        }
      }

      .content-top,
      .content-bottom {
        display: flex;
        justify-content: space-between;
      }
    }
    .icon_arrow {
      width: 24px;
      height: 24px;
    }
  }
  .bottom-content {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
<template>
  <div class="common">
    <div class="common-wrapper">
      <div class="common-title">
        <img :src="$setPicSize(icon, 1000)" alt="" />
      </div>
      <div class="common-content">
        <div class="content-top" @click="topClick">
          <slot name="contentTop"></slot>
          <img
            v-show="showTopArrow"
            :src="
              $setPicSize(
                'https://pic2.zhuanstatic.com/zhuanzh/90003314-29ea-4062-9088-e3d392fc1b06.png'
              )
            "
            class="icon_arrow"
            alt=""
          />
        </div>
        <div class="content-bottom" @click="bottomClick">
          <slot name="contentBottem"></slot>
          <img
            v-show="showBottomArrow"
            :src="
              $setPicSize(
                'https://pic2.zhuanstatic.com/zhuanzh/90003314-29ea-4062-9088-e3d392fc1b06.png'
              )
            "
            class="icon_arrow"
            alt=""
          />
        </div>
      </div>
      <!-- <img
        v-show="showArrow"
        :src="
          $setPicSize(
            'https://pic6.zhuanstatic.com/zhuanzh/ba948031-11ee-41a9-a176-2acc5029456d.png'
          )
        "
        class="icon_arrow"
        alt=""
      /> -->
    </div>

    <div class="bottom-content">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: '活动'
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'https://pic2.zhuanstatic.com/zhuanzh/13f4bbf0-c928-4922-bce7-8dffb16e9793.png'
    },
    // 顶部箭头是否展示
    showTopArrow: {
      type: Boolean,
      default: true
    },
    // 底部箭头是否展示
    showBottomArrow: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const parent = { ...context }

    const topClick = () => {
      parent.emit('listenTopClick')
    }
    const bottomClick = () => {
      parent.emit('listenBottomClick')
    }
    return { topClick, bottomClick }
  }
})
</script>
